import _ from 'lodash'
import React from 'react'
import {
  PreviewSkeletonType
  // SkeletonConfigType
} from 'src/lib/types/uiPreview'
import Pill from './Pill'

interface LoadingPhoneInputProps {
  borderColor: string | undefined
  skeleton: PreviewSkeletonType
}

const LoadingPhoneInput: React.FC<LoadingPhoneInputProps> = ({ borderColor, skeleton }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '0.75rem',
        width: '100%',
        border: `2px solid ${borderColor}`,
        borderRadius: '16px',
        gap: 6
      }}
    >
      {skeleton?.config?.map((item: any, index: number) => {
        return <Pill height={item?.height} width={item?.width} key={index} />
      })}
    </div>
  )
}

export default LoadingPhoneInput
